export default __webpack_public_path__ + "static/inrbanktransfer-f7aa06c2f8b63e8ad51e817e6610803a.svg";